import request from '@/utils/http.js';

// 发起端-开始增加虚拟观众
const virtualClientStart = (params = {}) => {

  return request({
    url: '/v3/webinars/virtual/start',
    method: 'GET',
    params: params
  });
};
//虚拟人数设置
const virtualClientSet = (params = {}) => {
  return request({
    url: '/v3/webinars/virtual/set',
    method: 'POST',
    data: params
  });
};
const virtualClientStop = (params = {}) => {
  return request({
    url: '/v3/webinars/virtual/stop',
    method: 'Post',
    data: params
  });
}
// 发起端-获取虚拟人数设置
const getVirtualSettings = (params = {}) => {
  return request({
    url: '/v3/webinars/virtual/get-last-config',
    method: 'GET',
    params: params
  });
}
// 发起端-增加虚拟观众
const virtualAccumulation = (params = {}) => {

  return request({
    url: '/v3/webinars/virtual/accumulation',
    method: 'GET',
    params: params
  });
};

// 发起端-获取虚拟观众基数
const virtualClientGet = (params = {}) => {

  return request({
    url: '/v3/webinars/virtual/get-base',
    method: 'GET',
    params: params
  });
};
const getVirtualLikes = (params = {}) => {
  return request({
    url: '/v3/interacts/like/get-room-like',
    method: 'GET',
    params: params
  });
};
const getVirtualLikesSet = (params = {}) => {
  return request({
    url: '/v3/interacts/like/get-config',
    method: 'GET',
    params: params
  });
};
const setVirtualLikes = (params = {}) => {
  return request({
    url: '/v3/interacts/like/set-config',
    method: 'POST',
    data: params
  });
}
const virtualClient = {
  virtualClientStart,
  virtualClientSet,
  virtualClientStop,
  getVirtualSettings,
  virtualAccumulation,
  virtualClientGet,
  getVirtualLikesSet,
  getVirtualLikes,
  setVirtualLikes,

};

export default virtualClient;
